var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { busService } from "../../../modules/bus";
import { EnableWebXRMessage } from "../../../messages/xr/WebXRMessages";
import { AskOkMessage } from "flavr-common";
import i18next from "i18next";
export var SessionViewUtils;
(function (SessionViewUtils) {
    let SessionViewDialogType;
    (function (SessionViewDialogType) {
        SessionViewDialogType[SessionViewDialogType["none"] = 0] = "none";
        SessionViewDialogType[SessionViewDialogType["switchSession"] = 1] = "switchSession";
        SessionViewDialogType[SessionViewDialogType["options"] = 2] = "options";
        SessionViewDialogType[SessionViewDialogType["modelUpload"] = 3] = "modelUpload";
    })(SessionViewDialogType = SessionViewUtils.SessionViewDialogType || (SessionViewUtils.SessionViewDialogType = {}));
    SessionViewUtils.defaultPanelState = {
        showRightSidePanel: false,
        showConference: true,
        showLeftSidePanel: false,
        topLeftMenuPinned: true,
        topRightMenuPinned: true,
        bottomMenuPinned: false
    };
    function getPersistedPanelState() {
        try {
            const panelStateString = localStorage.getItem(SessionViewUtils.panelStateKey);
            if (panelStateString) {
                return JSON.parse(panelStateString);
            }
        }
        catch (e) {
            console.error("Error while loading panel state from local storage", e);
        }
        return SessionViewUtils.defaultPanelState;
    }
    SessionViewUtils.getPersistedPanelState = getPersistedPanelState;
    SessionViewUtils.panelStateKey = "sessionViewPanelState";
    // Overlaying a button over XR View only works when this button is directly appended to body
    function createLeaveVRButton(onEnded, onLiveViewToggle, onPeerLiveViewToggle) {
        const container = document.createElement("div");
        container.className = "vr-controls";
        const leaveVRButton = document.createElement("button");
        leaveVRButton.className = "leave-vr-button";
        leaveVRButton.onclick = () => {
            busService
                .connection("SessionView")
                .askByMessageType(new EnableWebXRMessage(false), AskOkMessage)
                .finally(() => {
                removeLeaveVRButton();
                onEnded();
            });
        };
        const icon = document.createElement("i");
        icon.className = "fas fa-vr-cardboard";
        leaveVRButton.appendChild(icon);
        const span = document.createElement("span");
        span.innerText = i18next.t("sessionview:button-leave-vr", "Leave VR");
        leaveVRButton.appendChild(span);
        const liveViewButton = document.createElement("button");
        liveViewButton.className = "live-view-button";
        liveViewButton.onclick = () => __awaiter(this, void 0, void 0, function* () {
            const active = yield onLiveViewToggle();
            updateLiveViewButton(container, active);
        });
        const liveViewIcon = document.createElement("i");
        liveViewIcon.className = "fas fa-video";
        liveViewButton.appendChild(liveViewIcon);
        const liveViewSpan = document.createElement("span");
        liveViewSpan.innerText = i18next.t("sessionview:button-start-live-view", "Start Live View");
        liveViewButton.appendChild(liveViewSpan);
        const peerLiveViewButton = document.createElement("button");
        peerLiveViewButton.className = "live-view-button";
        peerLiveViewButton.onclick = () => __awaiter(this, void 0, void 0, function* () {
            const active = yield onPeerLiveViewToggle();
            peerLiveViewButton.classList.toggle("live-view-button-active", active);
            peerLiveViewButton.querySelector("span").textContent = i18next.t(active ? "sessionview:button-stop-live-view-sharing" : "sessionview:button-start-live-view-sharing", active ? "Stop sharing Live View" : "Share Live View");
        });
        const peerLiveViewIcon = document.createElement("i");
        peerLiveViewIcon.className = "fas fa-users";
        peerLiveViewButton.appendChild(peerLiveViewIcon);
        const peerLiveViewSpan = document.createElement("span");
        peerLiveViewSpan.innerText = i18next.t("sessionview:button-start-live-view-sharing", "Share Live View");
        peerLiveViewButton.appendChild(peerLiveViewSpan);
        container.appendChild(liveViewButton);
        container.appendChild(peerLiveViewButton);
        container.appendChild(leaveVRButton);
        return container;
    }
    SessionViewUtils.createLeaveVRButton = createLeaveVRButton;
    function updateLiveViewButton(container, active) {
        const button = container.querySelector(".live-view-button");
        if (!button)
            return;
        button.classList.toggle("live-view-button-active", active);
        button.querySelector("span").textContent = i18next.t(active ? "sessionview:button-stop-live-view" : "sessionview:button-start-live-view", active ? "Stop Live View" : "Start Live View");
    }
    SessionViewUtils.updateLiveViewButton = updateLiveViewButton;
    function removeLeaveVRButton() {
        const controls = document.getElementsByClassName("vr-controls");
        for (let i = 0; i < controls.length; i++) {
            controls[i].remove();
        }
    }
    SessionViewUtils.removeLeaveVRButton = removeLeaveVRButton;
})(SessionViewUtils || (SessionViewUtils = {}));
